export default {
  title: 'Welcome to Control Tower System',
  subtitle: 'Your intelligent logistics management platform for simpler and more efficient freight',
  quickAccess: 'Quick Access',
  enterSystem: 'Enter System',
  settings: 'Settings',
  settingsTitle: 'Quick Access Settings',
  approval: {
    title: 'Approval Matters',
    refresh: 'Refresh',
    moreFilter: 'More Filters',
    search: 'Search',
    reset: 'Reset',
    searchPlaceholder: 'Workflow name / approval no.',
    empty: 'No approval matters',
    currentScope: 'Current: {scope}',
    tree: {
      initiated: 'Approvals I Initiated',
      processing: 'Approvals I Handle'
    },
    categories: {
      billPayment: 'Payment Application',
      makeInvoice: 'Invoice Application',
      jobCharge: 'Business Fee Application',
      tempCredit: 'Temporary Credit Application',
      chargeChange: 'Fee Change Application',
      collectInvoice: 'Invoice Collection Application',
      partnerApplication: 'Partner Application',
      contractApplication: 'Contract Application',
      advancePaymentRefund: 'Advance Payment Refund Application',
      customFormPrefix: '{name}',
      platformCategories: {
        inquiryFcl: 'Shokz FCL Inquiry Price Comparison Confirmation',
        inquiryLcl: 'Shokz LCL Inquiry Price Comparison Confirmation',
        inquiryAir: 'Shokz Air Freight Inquiry Price Comparison Confirmation',
        inquiryPrePort: 'Shokz Pre-carriage Inquiry Price Comparison Confirmation',
        inquiryLastMile: 'Shokz Last Mile Inquiry Price Comparison Confirmation',
        tcFee: 'Supplier Reconciliation',
        settlementBillApproval: 'Settlement Bill Approval',
        specialPriceApplication: 'Special Price Application',
        transportConsignmentFeeChange: 'Transport Consignment Fee Change'
      }
    },
    states: {
      all: 'All',
      processing: 'Processing',
      completed: 'Completed',
      ordered: 'Ordered',
      cancelled: 'Cancelled',
      abandoned: 'Abandoned'
    },
    columns: {
      index: 'No.',
      documentProcessNo: 'Approval No.',
      applicationDimension: 'Application Dimension',
      applicationCode: 'Business No.',
      feeChangeApplicationCode: 'Application Code',
      documentConfigName: 'Form Type',
      docNo: 'Business No.',
      createDate: 'Created At',
      workflowName: 'Workflow Name',
      currentApprover: 'Current Approver',
      state: 'Status',
      officeName: 'Initiating Branch',
      initiateBranchCompany: 'Initiating Branch',
      creator: 'Initiator',
      lastModified: 'Updated At',
      consignor: 'Entrusting Company',
      supplierName: 'Supplier Name',
      businessCreatedAt: 'Business Created At',
      etd: 'ETD',
      eta: 'ETA',
      atd: 'ATD',
      ata: 'ATA',
      action: 'Action'
    },
    applicationDimensions: {
      inquiry: 'Inquiry',
      bill: 'Bill',
      transportConsignment: 'Transport Consignment'
    },
    actions: {
      process: 'Process',
      orderNow: 'Order Now',
      approve: 'Approve',
      reject: 'Reject',
      undo: 'Withdraw',
      rollback: 'Revoke',
      return: 'Return',
      cancel: 'Cancel',
      addSignature: 'Add Signer',
      transferSignature: 'Transfer',
      viewHistory: 'View History'
    },
    detail: {
      title: 'Approval Processing',
      basicInfo: 'Basic Info',
      businessInfo: 'Business Details',
      businessEmpty: 'No business fields',
      remarkTitle: 'Approval Comment',
      remarkPlaceholder: 'Enter approval comment',
      attachmentTitle: 'Approval Attachments',
      uploadAttachment: 'Upload Attachment',
      uploadingAttachment: 'Attachment is still uploading, please wait',
      attachmentSizeLimit: 'Each attachment must be no larger than 20MB',
      attachmentSizeLimitWithMb: 'Each attachment must be no larger than {size}MB',
      attachmentTypeLimit: 'Only PDF, JPG, and PNG attachments are supported',
      fileMissing: 'File information is missing',
      uploadFailed: 'Attachment upload failed',
      downloadFailed: 'Attachment download failed',
      unknownFile: 'Unknown file',
      addSignaturePlaceholder: 'Select signers, search by name, account, or phone',
      transferSignaturePlaceholder: 'Select a transfer signer, search by name, account, or phone',
      availableActions: 'Available Actions',
      noAvailableActions: 'No available actions',
      workflowRecords: 'Workflow Records',
      noWorkflowRecords: 'No workflow records',
      nodeFallback: 'Node {node}',
      operatorLabel: 'Operator: ',
      remarkLabel: 'Remark: ',
      noRemark: 'None',
      fixedApprover: 'Fixed approver: {users}',
      disableAddSignature: 'Cannot add signer: {users}',
      hintSeparator: '; ',
      selectAddSignatureUser: 'Please select signers',
      selectTransferSignatureUser: 'Please select a transfer signer',
      disabledAddSignatureUsers: 'The following users cannot be added as signers: {users}',
      confirmTitle: 'Approval Confirmation',
      confirmContent: 'Are you sure to perform [{action}]?',
      success: 'Approval processed successfully'
    },
    panel: {
      flowInfo: 'Workflow Info',
      flowNo: 'Workflow No.',
      flowName: 'Workflow Name',
      initiator: 'Initiator',
      applyTime: 'Start Time',
      currentApprover: 'Current Approver',
      relatedDoc: 'Related Document',
      progress: 'Approval Progress',
      progressPending: 'Pending Approval',
      attachments: 'Approval Attachments',
      noAttachments: 'No attachments',
      download: 'Download',
      remark: 'Remark',
      remarkPlaceholder: 'Enter approval remark (optional)',
      noActions: 'No actions available',
      approve: 'Approve',
      reject: 'Reject',
      return: 'Return',
      rollback: 'Rollback',
      cancel: 'Void',
      undo: 'Withdraw',
      confirmTitle: 'Confirm Action',
      confirmContent: 'Proceed with "{action}"?',
      actionSuccess: 'Action completed',
      actionFailed: 'Approval action failed',
      loadFailed: 'Failed to load approval info',
      defaultFlowName: 'Approval Workflow'
    },
    filters: {
      title: 'Approval Filters',
      workflowName: 'Workflow Name',
      documentProcessNo: 'Approval No.',
      docNo: 'Business No.',
      approveByName: 'Approver',
      officeName: 'Company',
      state: 'Status'
    },
    batch: {
      approve: 'Approve',
      reject: 'Reject',
      emptySelection: 'Please select approval matters',
      confirmTitle: 'Batch Approval Confirmation',
      confirmContent: 'Are you sure to {action} {count} selected approval matters?',
      success: '{action} succeeded',
      partialFailed: 'Some approval matters failed'
    },
    history: {
      title: 'Workflow History',
      basicInfo: 'Basic Info',
      timeline: 'Approval Records',
      empty: 'No workflow history',
      node: 'Node',
      currentNode: 'Current Node',
      approver: 'Approver',
      remark: 'Remark',
      noRemark: 'None',
      missingProcessId: 'Missing process ID, unable to view workflow history'
    }
  },
  shortcuts: {
    rateQuery: 'Rate Query',
    inquiryManagement: 'Inquiry Management',
    quotationManagement: 'Quotation Management',
    rateMaintenance: 'Rate Maintenance',
    orderManagement: 'Order Management',
    scheduleQuery: 'Schedule Query',
    controlTower: 'Control Tower Panel',
    customerCenter: 'Customer & Vendor Center',
    userCenter: 'User Center',
    apiCenter: 'API Center',
    applicationCenter: 'Application Center',
    systemSettings: 'System Settings'
  }
}
